
    export const translations = {
      "de":{
  "control-center": "Kontrollzentrum",
  "theme": "Theme",
  "focus-mode": "Fokus-Modus",
  "focus-mode-aktiviert": "Fokus-Modus aktiviert",
  "focus-mode-deaktiviert": "Fokus-Modus deaktiviert",
  "night-mode": "Nachtmodus",
  "quick-notes": "Schnellnotizen",
  "quick-notes-new": "Neue Notiz",
  "quick-notes-delete": "Löschen",
  "quick-notes-delete-confirm": "Möchtest du diese Notiz wirklich löschen?",
  "quick-notes-empty": "Leere Notiz",
  "quick-notes-no-notes": "Keine Notizen vorhanden",
  "quick-notes-create-first": "Erste Notiz erstellen",
  "quick-notes-select": "Wähle eine Notiz aus",
  "drag-to-reorder": "Ziehen zum Sortieren",
  "abmelden": "Abmelden",
  "anmelden": "Anmelden",
  "angemeldet-als": "Angemeldet als",
  "error": "Fehler",
  "seite-existiert-nicht-text": "Die angeforderte Seite wurde nicht gefunden. Wenn sie sicher sind, dass die Seite {{link}} existiert, wenden sie sich bitte an die IT um ihre Berechtigungen prüfen zu lassen.",
  "seite-existiert-nicht-login-text": "Die angeforderte Seite wurde nicht gefunden. Bitte loggen sie sich ein um es erneut zu versuchen.",
  "schnee": "Schnee",
  "schneefall": "Schneefall",
  "stufe": "Stufe",
  "zur-startseite": "Zur Startseite",
  "feed-server-offline": "Der Feed-Server ist nicht erreichbar.",
  "bitte-versuche-es-spaeter-nochmal": "Bitte versuche es später nochmal.",
  "account-verwalten": "Account verwalten",
  "dark-mode": "Dunkel",
  "light-mode": "Hell",
  "apps": "Apps",
  "impressum": "Impressum",
  "impressum-link": "https://salamander-windows.com/rechtliches/impressum",
  "bitte-melden-sie-sich-an": "Bitte melden sie sich an",
  "theme-wechseln": "Theme wechseln",
  "account": "Account",
  "search-pilets": "Spotlight Suche",
  "no-pilets-found": "Keine Pilets gefunden für \"{{query}}\"",
  "clear-cache": "LocalStorage leeren",
  "clear-cache-confirm": "Möchtest du wirklich den LocalStorage leeren? Alle lokalen Einstellungen gehen verloren.",
  "show-version": "Version anzeigen",
  "no-history": "Keine letzten Einträge",
  "recent-history": "Zuletzt verwendet",
  "actions": "Aktionen",
  "search-page": "Auf Seite suchen",
  "page-results": "Ergebnisse auf Seite",
  "no-page-results": "Keine Treffer auf dieser Seite",
  "shortcut-ctrl": "Strg",
  "release-notes": "Versionshinweise",
  "versions": "Versionen",
  "new": "Neu",
  "update-available": "Neues Update veröffentlicht!",
  "update-description": "Wir haben neue Funktionen und Verbesserungen hinzugefügt.",
  "view-release-notes": "Versionshinweise anzeigen",
  "cancel": "Abbrechen",
  "confirm": "Bestätigen",
  "delete": "Löschen",
  "notes": "Notizen",
  "done": "Fertig",
  "edit": "Bearbeiten",
  "reset": "Zurücksetzen",
  "calendar": "Kalender",
  "today": "Heute",
  "sun-times": "Sonnenzeiten",
  "sunrise": "Sonnenaufgang",
  "sunset": "Sonnenuntergang",
  "daylight": "Tageslicht",
  "moonlight": "Mondlicht",
  "first-light": "Erstes Licht",
  "last-light": "Letztes Licht",
  "time-type": "Zeittyp",
  "summer-time": "Sommerzeit",
  "winter-time": "Winterzeit",
  "change": "Umstellung",
  "shift": "Änderung",
  "show-sun": "Sonne anzeigen",
  "show-moon": "Mond anzeigen",
  "moonrise": "Mondaufgang",
  "moonset": "Monduntergang",
  "moon-phase": "Mondphase",
  "illumination": "Beleuchtung",
  "new-moon": "Neumond",
  "waxing-crescent": "Zunehmende Sichel",
  "first-quarter": "Erstes Viertel",
  "waxing-gibbous": "Zunehmender Mond",
  "full-moon": "Vollmond",
  "waning-gibbous": "Abnehmender Mond",
  "last-quarter": "Letztes Viertel",
  "waning-crescent": "Abnehmende Sichel",
  "next-full-moon": "Nächster Vollmond",
  "days": "Tage",
  "fireflies": "Glühwürmchen"
}
,"en":{
  "control-center": "Control Center",
  "theme": "Theme",
  "focus-mode": "Focus Mode",
  "focus-mode-aktiviert": "Focus Mode enabled",
  "focus-mode-deaktiviert": "Focus Mode disabled",
  "night-mode": "Night Mode",
  "quick-notes": "Quick Notes",
  "quick-notes-new": "New Note",
  "quick-notes-delete": "Delete",
  "quick-notes-delete-confirm": "Are you sure you want to delete this note?",
  "quick-notes-empty": "Empty note",
  "quick-notes-no-notes": "No notes yet",
  "quick-notes-create-first": "Create your first note",
  "quick-notes-select": "Select a note",
  "drag-to-reorder": "Drag to reorder",
  "abmelden": "Logout",
  "account-verwalten": "Manage Account",
  "angemeldet-als": "Logged in as",
  "anmelden": "Login",
  "apps": "Apps",
  "bitte-versuche-es-spaeter-nochmal": "Please try again later.",
  "dark-mode": "Dark",
  "error": "Error",
  "feed-server-offline": "The feed server cannot be reached.",
  "light-mode": "Light",
  "seite-existiert-nicht-text": "The requested page was not found. If you are sure that the page {{link}} exists, please contact IT to check your permissions.",
  "seite-existiert-nicht-login-text": "The requested page was not found. Please log in to try again.",
  "schnee": "Snow",
  "schneefall": "Snowfall",
  "stufe": "Level",
  "zur-startseite": "Back to start page",
  "impressum": "imprint",
  "impressum-link": "https://salamander-windows.com/legal/imprint",
  "bitte-melden-sie-sich-an": "Please log in",
  "theme-wechseln": "Change theme",
  "account": "Account",
  "search-pilets": "Spotlight Search",
  "no-pilets-found": "No pilets found for \"{{query}}\"",
  "clear-cache": "Clear LocalStorage",
  "clear-cache-confirm": "Are you sure you want to clear LocalStorage? All local settings will be lost.",
  "show-version": "Show Version",
  "no-history": "No recent items",
  "recent-history": "Recent",
  "actions": "Actions",
  "search-page": "Search on page",
  "page-results": "Results on page",
  "no-page-results": "No matches found on this page",
  "shortcut-ctrl": "Ctrl",
  "release-notes": "Versionshinweise",
  "versions": "Versionen",
  "new": "Neu",
  "update-available": "Neues Update veröffentlicht!",
  "update-description": "Wir haben neue Funktionen und Verbesserungen hinzugefügt.",
  "view-release-notes": "View release notes",
  "cancel": "Cancel",
  "confirm": "Confirm",
  "delete": "Delete",
  "notes": "Notes",
  "done": "Done",
  "edit": "Edit",
  "reset": "Reset",
  "calendar": "Calendar",
  "today": "Today",
  "sun-times": "Sun Times",
  "sunrise": "Sunrise",
  "sunset": "Sunset",
  "daylight": "Daylight",
  "moonlight": "Moonlight",
  "first-light": "First Light",
  "last-light": "Last Light",
  "time-type": "Time Type",
  "summer-time": "Summer",
  "winter-time": "Winter",
  "change": "Change",
  "shift": "Shift",
  "show-sun": "Show Sun",
  "show-moon": "Show Moon",
  "moonrise": "Moonrise",
  "moonset": "Moonset",
  "moon-phase": "Moon Phase",
  "illumination": "Illumination",
  "new-moon": "New Moon",
  "waxing-crescent": "Waxing Crescent",
  "first-quarter": "First Quarter",
  "waxing-gibbous": "Waxing Gibbous",
  "full-moon": "Full Moon",
  "waning-gibbous": "Waning Gibbous",
  "last-quarter": "Last Quarter",
  "waning-crescent": "Waning Crescent",
  "next-full-moon": "Next Full Moon",
  "days": "days",
  "fireflies": "Fireflies"
}
,"es":{
  "control-center": "Centro de control",
  "theme": "Tema",
  "night-mode": "Modo nocturno",
  "abmelden": "Cerrar sesión",
  "anmelden": "Iniciar sesión",
  "angemeldet-als": "Conectado como",
  "error": "Errorinio",
  "seite-existiert-nicht-text": "No se pudo encontrar la página solicitada. Si está seguro de que la página {{link}} existe, por favor contacte con IT para verificar sus permisos.",
  "seite-existiert-nicht-login-text": "No se pudo encontrar la página solicitada. Por favor, inicie sesión para intentarlo de nuevo.",
  "schnee": "Nieve",
  "schneefall": "Nevada",
  "stufe": "Nivel",
  "zur-startseite": "Volver a la página de inicio",
  "account-verwalten": "Administrar cuenta",
  "dark-mode": "Modo oscuro",
  "light-mode": "Modo claro",
  "apps": "Aplicaciones",
  "bitte-versuche-es-spaeter-nochmal": "Por favor, inténtelo de nuevo más tarde.",
  "feed-server-offline": "No se puede acceder al servidor de feeds.",
  "impressum": "Aviso legal",
  "impressum-link": "https://salamander-windows.com/rechtliches/impressum",
  "bitte-melden-sie-sich-an": "Por favor, inicie sesión",
  "theme-wechseln": "Cambiar tema",
  "account": "Cuenta",
  "search-pilets": "Spotlight Búsqueda",
  "no-pilets-found": "No se encontraron pilets para \"{{query}}\"",
  "clear-cache": "Limpiar LocalStorage",
  "clear-cache-confirm": "¿Estás seguro de que quieres limpiar el LocalStorage? Se perderán todas las configuraciones locales.",
  "show-version": "Mostrar versión",
  "no-history": "No hay elementos recientes",
  "recent-history": "Reciente",
  "actions": "Acciones",
  "search-page": "Buscar en página",
  "page-results": "Resultados en página",
  "no-page-results": "No se encontraron coincidencias en esta página",
  "shortcut-ctrl": "Ctrl",
  "release-notes": "Versionshinweise",
  "versions": "Versionen",
  "new": "Neu",
  "update-available": "Neues Update veröffentlicht!",
  "update-description": "Wir haben neue Funktionen und Verbesserungen hinzugefügt.",
  "view-release-notes": "Versionshinweise anzeigen",
  "drag-to-reorder": "Arrastra para ordenar",
  "focus-mode": "Modo de enfoque",
  "focus-mode-aktiviert": "Modo de enfoque activado",
  "focus-mode-deaktiviert": "Modo de enfoque desactivado",
  "quick-notes": "Notas rápidas",
  "quick-notes-create-first": "Crear primera nota",
  "quick-notes-delete": "Borrar",
  "quick-notes-delete-confirm": "¿Estás seguro de que quieres eliminar esta nota?",
  "quick-notes-empty": "nota en blanco",
  "quick-notes-new": "Nueva nota",
  "quick-notes-no-notes": "No hay notas disponibles",
  "quick-notes-select": "Seleccione una nota",
  "cancel": "Cancelar",
  "confirm": "Confirmar",
  "delete": "Eliminar",
  "notes": "Notas",
  "done": "Hecho",
  "edit": "Editar",
  "reset": "Restablecer",
  "calendar": "Calendario",
  "today": "Hoy",
  "sun-times": "Horario solar",
  "sunrise": "Amanecer",
  "sunset": "Atardecer",
  "daylight": "Luz del día",
  "moonlight": "Luz de luna",
  "first-light": "Primera luz",
  "last-light": "Última luz",
  "time-type": "Tipo de hora",
  "summer-time": "Verano",
  "winter-time": "Invierno",
  "change": "Cambio",
  "shift": "Cambio",
  "show-sun": "Mostrar Sol",
  "show-moon": "Mostrar Luna",
  "moonrise": "Salida de luna",
  "moonset": "Puesta de luna",
  "moon-phase": "Fase lunar",
  "illumination": "Iluminación",
  "new-moon": "Luna nueva",
  "waxing-crescent": "Creciente",
  "first-quarter": "Cuarto creciente",
  "waxing-gibbous": "Gibosa creciente",
  "full-moon": "Luna llena",
  "waning-gibbous": "Gibosa menguante",
  "last-quarter": "Cuarto menguante",
  "waning-crescent": "Menguante",
  "next-full-moon": "Próxima luna llena",
  "days": "días",
  "fireflies": "Luciérnagas"
}
,"pl":{
  "control-center": "Centrum sterowania",
  "theme": "Motyw",
  "night-mode": "Tryb nocny",
  "abmelden": "Wyloguj",
  "account-verwalten": "Zarządzaj kontem",
  "angemeldet-als": "Zalogowany jako",
  "anmelden": "Zaloguj",
  "apps": "Aplikacje",
  "bitte-versuche-es-spaeter-nochmal": "Spróbuj ponownie później.",
  "dark-mode": "Ciemny",
  "error": "Błąd",
  "feed-server-offline": "Nie można uzyskać dostępu do serwera kanałów informacyjnych.",
  "light-mode": "Jasny",
  "seite-existiert-nicht-text": "Żądana strona nie została znaleziona. Jeśli jesteś pewien, że strona {{link}} istnieje, skontaktuj się z IT, aby sprawdzić swoje uprawnienia.",
  "seite-existiert-nicht-login-text": "Żądana strona nie została znaleziona. Zaloguj się i spróbuj ponownie.",
  "schnee": "Śnieg",
  "schneefall": "Opad śniegu",
  "stufe": "Poziom",
  "zur-startseite": "Do strony głównej",
  "impressum": "Informacje o firmie",
  "impressum-link": "https://salamander-windows.com/prawne/impressum",
  "bitte-melden-sie-sich-an": "Zaloguj się",
  "theme-wechseln": "Zmień motyw",
  "account": "Konto",
  "search-pilets": "Spotlight Szukaj",
  "no-pilets-found": "Nie znaleziono piletów dla \"{{query}}\"",
  "clear-cache": "Wyczyść LocalStorage",
  "clear-cache-confirm": "Czy na pewno chcesz wyczyścić LocalStorage? Wszystkie lokalne ustawienia zostaną utracone.",
  "show-version": "Pokaż wersję",
  "no-history": "Brak ostatnich elementów",
  "recent-history": "Ostatnie",
  "actions": "Akcje",
  "search-page": "Szukaj na stronie",
  "page-results": "Wyniki na stronie",
  "no-page-results": "Nie znaleziono dopasowań na tej stronie",
  "shortcut-ctrl": "Ctrl",
  "release-notes": "Versionshinweise",
  "versions": "Versionen",
  "new": "Neu",
  "update-available": "Neues Update veröffentlicht!",
  "update-description": "Wir haben neue Funktionen und Verbesserungen hinzugefügt.",
  "view-release-notes": "Versionshinweise anzeigen",
  "drag-to-reorder": "Przeciągnij, aby posortować",
  "focus-mode": "Tryb ostrości",
  "focus-mode-aktiviert": "Włączono tryb ostrości",
  "focus-mode-deaktiviert": "Tryb ostrości wyłączony",
  "quick-notes": "Szybkie notatki",
  "quick-notes-create-first": "Utwórz pierwszą notatkę",
  "quick-notes-delete": "Usuń",
  "quick-notes-delete-confirm": "Czy na pewno chcesz usunąć tę notatkę?",
  "quick-notes-empty": "Pusta notatka",
  "quick-notes-new": "Nowa notatka",
  "quick-notes-no-notes": "Brak dostępnych notatek",
  "quick-notes-select": "Wybierz notatkę",
  "cancel": "Anuluj",
  "confirm": "Potwierdź",
  "delete": "Usuń",
  "notes": "Notatki",
  "done": "Gotowe",
  "edit": "Edytuj",
  "reset": "Resetuj",
  "calendar": "Kalendarz",
  "today": "Dziś",
  "sun-times": "Czas słoneczny",
  "sunrise": "Wschód słońca",
  "sunset": "Zachód słońca",
  "daylight": "Światło dzienne",
  "moonlight": "Światło księżyca",
  "first-light": "Pierwszy świt",
  "last-light": "Ostatni zmierzch",
  "time-type": "Typ czasu",
  "summer-time": "Czas letni",
  "winter-time": "Czas zimowy",
  "change": "Zmiana",
  "shift": "Przesunięcie",
  "show-sun": "Pokaż Słońce",
  "show-moon": "Pokaż Księżyc",
  "moonrise": "Wschód księżyca",
  "moonset": "Zachód księżyca",
  "moon-phase": "Faza księżyca",
  "illumination": "Iluminacja",
  "new-moon": "Nów",
  "waxing-crescent": "Przybywający sierp",
  "first-quarter": "Pierwsza kwadra",
  "waxing-gibbous": "Przybywający garb",
  "full-moon": "Pełnia",
  "waning-gibbous": "Ubywający garb",
  "last-quarter": "Ostatnia kwadra",
  "waning-crescent": "Ubywający sierp",
  "next-full-moon": "Następna pełnia",
  "days": "dni",
  "fireflies": "Świetliki"
}

    }
  